import { useState } from 'react';

const budgets = ['100만원 미만', '100~300만원', '300~500만원', '500만~1,000만원', '1,000만원 이상'];

const inputStyle = (focused, field) => ({
  width: '100%',
  background: focused === field ? '#EDE9E1' : '#F7F4EF',
  border: '1px solid',
  borderColor: focused === field ? '#1A1818' : '#C8B8A2',
  padding: '10px 12px',
  color: '#1A1818',
  fontSize: '14px',
  fontFamily: '"Inter", system-ui, sans-serif',
  outline: 'none',
  transition: 'all 0.15s ease',
});

export default function Contact() {
  const [form, setForm] = useState({ name:'', company:'', email:'', budget:'', message:'' });
  const [submitted, setSubmitted] = useState(false);
  const [focused, setFocused] = useState(null);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div id="contact" className="py-16 border-b-4 border-ink bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 border border-rule-2 bg-paper">
          {/* Left editorial block */}
          <div className="lg:col-span-4 border-b lg:border-b-0 lg:border-r border-rule-2 p-8">
            <h3 className="font-headline font-bold text-2xl text-ink mb-4 italic">
              "브랜드 성장의 첫 걸음은 대화에서 시작됩니다."
            </h3>
            <p className="font-serif text-sm text-dim leading-relaxed mb-6">
              무료 상담을 신청하시면 전담 컨설턴트가 영업일 기준 24시간 이내에 연락드립니다.
              귀사의 현황을 분석하고 최적의 마케팅 전략을 제안해드립니다.
            </p>

            <div className="border-t-2 border-ink pt-5 space-y-4">
              {[
                { label:'상담 비용',   val:'완전 무료' },
                { label:'응답 시간',   val:'영업일 24시간 이내' },
                { label:'담당 배정',   val:'제출 즉시' },
                { label:'운영 시간',   val:'평일 09:00–18:00' },
              ].map(item => (
                <div key={item.label} className="flex items-center justify-between border-b border-rule-2 pb-3 last:border-0 last:pb-0">
                  <span className="font-mono text-xs text-dim uppercase">{item.label}</span>
                  <span className="font-sans font-semibold text-sm text-ink">{item.val}</span>
                </div>
              ))}
            </div>

            {/* Ad block */}
            <div className="mt-8 border-2 border-ink p-5 text-center">
              <p className="font-mono text-xs text-dim mb-1 tracking-widest uppercase">광고 안내</p>
              <p className="font-headline font-black text-3xl text-red mb-1">무료</p>
              <p className="font-serif text-sm text-ink italic">브랜드 진단 상담</p>
            </div>
          </div>

          {/* Right form */}
          <div className="lg:col-span-8 p-8">
            {submitted ? (
              <div className="py-16 text-center border-2 border-ink">
                <p className="font-mono text-xs text-red tracking-widest uppercase mb-3">전송 완료</p>
                <h3 className="font-headline font-black text-3xl text-ink mb-3">상담 신청이 접수됐습니다</h3>
                <p className="font-serif text-dim">영업일 기준 24시간 이내 담당자가 연락드립니다.</p>
              </div>
            ) : (
              <form onSubmit={e => { e.preventDefault(); setSubmitted(true); }} className="space-y-5">
                <div className="border-b-2 border-ink pb-4 mb-5">
                  <p className="font-mono text-xs text-dim">상담 신청서 · CONSULTATION REQUEST FORM</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block font-mono text-xs text-dim uppercase mb-1.5">이름 *</label>
                    <input type="text" required value={form.name} onChange={set('name')}
                      placeholder="홍길동" style={inputStyle(focused,'name')}
                      onFocus={() => setFocused('name')} onBlur={() => setFocused(null)} />
                  </div>
                  <div>
                    <label className="block font-mono text-xs text-dim uppercase mb-1.5">회사명</label>
                    <input type="text" value={form.company} onChange={set('company')}
                      placeholder="(주)회사명" style={inputStyle(focused,'company')}
                      onFocus={() => setFocused('company')} onBlur={() => setFocused(null)} />
                  </div>
                </div>

                <div>
                  <label className="block font-mono text-xs text-dim uppercase mb-1.5">이메일 *</label>
                  <input type="email" required value={form.email} onChange={set('email')}
                    placeholder="example@company.com" style={inputStyle(focused,'email')}
                    onFocus={() => setFocused('email')} onBlur={() => setFocused(null)} />
                </div>

                <div>
                  <label className="block font-mono text-xs text-dim uppercase mb-1.5">월 예산 규모</label>
                  <select value={form.budget} onChange={set('budget')}
                    style={{ ...inputStyle(focused,'budget'), cursor:'pointer' }}
                    onFocus={() => setFocused('budget')} onBlur={() => setFocused(null)}>
                    <option value="">선택해주세요</option>
                    {budgets.map(b => <option key={b}>{b}</option>)}
                  </select>
                </div>

                <div>
                  <label className="block font-mono text-xs text-dim uppercase mb-1.5">문의 내용</label>
                  <textarea rows={4} value={form.message} onChange={set('message')}
                    placeholder="원하시는 서비스나 현재 마케팅 현황을 알려주세요"
                    style={{ ...inputStyle(focused,'message'), resize:'none' }}
                    onFocus={() => setFocused('message')} onBlur={() => setFocused(null)} />
                </div>

                <button type="submit" className="inline-flex items-center gap-2 bg-red text-paper font-sans font-semibold text-sm px-6 py-3 transition-all duration-200 hover:opacity-90 w-full justify-center py-3.5 font-bold"
                  style={{ display:'flex' }}>
                  무료 상담 신청하기 →
                </button>
                <p className="font-mono text-xs text-dim text-center">
                  제출 즉시 담당자 배정 · 영업일 24시간 내 답변 · 완전 무료
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
